function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function initVariantSelects() {
  document.querySelectorAll('variant-selects:not([data-initialized])').forEach(el => {
    el.dataset.initialized = 'true';
    el.addEventListener('change', function() {
      const sectionId = this.dataset.section;

      // Lire les options sélectionnées
      const options = Array.from(
        this.querySelectorAll('.product-form__input')
      ).map(input => {
        const select = input.querySelector('select');
        if (select) return select.value;
        const checkedRadio = input.querySelector('input[type="radio"]:checked');
        if (checkedRadio) return checkedRadio.value;
        return null;
      }).filter(Boolean);

      // Trouver le variant correspondant
      const variantsData = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );
      const currentVariant = variantsData.find(variant => {
        return !variant.options
          .map((option, index) => options[index] === option)
          .includes(false);
      });

      if (!currentVariant) return;

      // Mettre à jour l'image
      if (currentVariant.featured_media) {
        const mediaGallery = document.getElementById(`MediaGallery-${sectionId}`);
        if (mediaGallery) {
          mediaGallery.setActiveMedia(
            `${sectionId}-${currentVariant.featured_media.id}`,
            true
          );
        }
        const mediaGalleryDuplicate = document.getElementById(`MediaGallery-${sectionId}-duplicate`);
        if (mediaGalleryDuplicate) {
          mediaGalleryDuplicate.setActiveMedia(
            `${sectionId}-${currentVariant.featured_media.id}`,
            true
          );
        }
      }

      // Mettre à jour l'URL
      if (this.dataset.updateUrl !== 'false') {
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${currentVariant.id}`);
      }

      // Mettre à jour le formulaire
      const form = document.querySelector(`#product-form-${sectionId}`);
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input) input.value = currentVariant.id;
      }
    });
  });
}

// Initialisation au chargement
document.addEventListener('DOMContentLoaded', initVariantSelects);

// Réinitialisation quand l'éditeur Shopify recharge une section
document.addEventListener('shopify:section:load', initVariantSelects);